import React, { useState, createElement } from 'react';
import { Users, ShoppingBag, Shield, MessageSquare, Search, X, Phone, Video, Info, Calendar, CheckCircle2, Smile, Send, Paperclip, FileText, CheckCheck } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
import { VideoCallModal } from '../ui/VideoCallModal';
interface ChatTabProps {
  showToast: (msg: string) => void;
  setActiveTab: (tab: string) => void;
}
export function ChatTab({
  showToast,
  setActiveTab
}: ChatTabProps) {
  const [activeChat, setActiveChat] = useState(0);
  const [chatMessage, setChatMessage] = useState('');
  const [chatFilter, setChatFilter] = useState('all');
  const [showCallModal, setShowCallModal] = useState(false);
  const [callMode, setCallMode] = useState<'video' | 'audio'>('video');
  const chatConversations = [{
    name: 'Администрация',
    msg: 'Ваш профиль прошёл модерацию',
    time: '10:00',
    unread: 1,
    order: 'Системные уведомления',
    isAdmin: true,
    category: 'admin'
  }, {
    name: 'Поддержка платформы',
    msg: 'Ваш тикет #284 решён. Если есть вопросы — пишите.',
    time: 'Вчера',
    unread: 0,
    order: 'Тикет #284',
    isAdmin: true,
    category: 'admin'
  }, {
    name: 'Мария В.',
    msg: 'Спасибо большое! Очень помогло.',
    time: '14:30',
    unread: 0,
    order: '#1042 • Натальная карта',
    category: 'client'
  }, {
    name: 'Анна К.',
    msg: 'А можно уточнить по поводу...',
    time: 'Вчера',
    unread: 2,
    order: '#1038 • Соляр на год',
    category: 'client'
  }, {
    name: 'Иван С.',
    msg: 'Жду ссылку на созвон',
    time: 'Вчера',
    unread: 0,
    order: '#1035 • Синастрия',
    category: 'client'
  }, {
    name: 'Ольга П.',
    msg: 'Файл получен, изучаю',
    time: '12 Окт',
    unread: 0,
    order: '#1030 • Натальная карта',
    category: 'client'
  }, {
    name: 'Дмитрий Р.',
    msg: 'Купил курс «Основы астрологии», когда доступ?',
    time: '13:45',
    unread: 1,
    order: 'Курс «Основы астрологии»',
    category: 'sales'
  }, {
    name: 'Наталья С.',
    msg: 'Оплатила пакет разборов, жду подтверждения',
    time: 'Вчера',
    unread: 1,
    order: 'Пакет «Натал + Соляр + Синастрия»',
    category: 'sales'
  }, {
    name: 'Елена Т.',
    msg: 'Скачала астро-календарь, спасибо! Очень полезно',
    time: '10 Окт',
    unread: 0,
    order: 'Астро-календарь Ноябрь',
    category: 'sales'
  }, {
    name: 'Павел М.',
    msg: 'Можно ли получить запись вебинара?',
    time: '8 Окт',
    unread: 0,
    order: 'Вебинар «Ретроградный Меркурий»',
    category: 'sales'
  }];
  const chatTabs = [{
    id: 'all',
    label: 'Все',
    count: chatConversations.length
  }, {
    id: 'client',
    label: 'Клиенты',
    count: chatConversations.filter(c => c.category === 'client').length
  }, {
    id: 'sales',
    label: 'Продажи',
    count: chatConversations.filter(c => c.category === 'sales').length
  }, {
    id: 'admin',
    label: 'Система',
    count: chatConversations.filter(c => c.category === 'admin').length
  }];
  const filteredChats = chatFilter === 'all' ? chatConversations : chatConversations.filter(c => c.category === chatFilter);
  const unreadByCategory: Record<string, number> = {
    all: chatConversations.reduce((sum, c) => sum + c.unread, 0),
    client: chatConversations.filter(c => c.category === 'client').reduce((sum, c) => sum + c.unread, 0),
    sales: chatConversations.filter(c => c.category === 'sales').reduce((sum, c) => sum + c.unread, 0),
    admin: chatConversations.filter(c => c.category === 'admin').reduce((sum, c) => sum + c.unread, 0)
  };
  return <div className="space-y-4 h-[calc(100vh-12rem)] min-h-[500px] flex flex-col" data-id="element-12567">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 flex-shrink-0" data-id="element-12568">
        <h2 className="text-xl sm:text-2xl font-bold text-slate-900" data-id="element-12569">
          Чат с клиентами
        </h2>
        <div className="text-xs text-slate-500" data-id="element-12570">
          {chatConversations.reduce((sum, c) => sum + c.unread, 0) > 0 && <span className="inline-flex items-center gap-1.5 bg-rose-50 text-rose-600 font-medium px-2.5 py-1 rounded-full" data-id="element-12571">
              <span className="w-1.5 h-1.5 bg-rose-500 rounded-full animate-pulse" data-id="element-12572"></span>
              {chatConversations.reduce((sum, c) => sum + c.unread, 0)}{' '}
              непрочитанных
            </span>}
        </div>
      </div>

      {/* Category Tabs - prominent, full-width */}
      <div className="flex gap-1.5 bg-white p-1.5 rounded-xl border border-slate-100 shadow-sm overflow-x-auto scrollbar-hide flex-shrink-0" data-id="element-12573">
        {chatTabs.map(tab => <button key={tab.id} onClick={() => {
        setChatFilter(tab.id);
        setActiveChat(-1);
      }} className={`relative flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-all flex-1 justify-center min-w-0 ${chatFilter === tab.id ? 'bg-primary text-white shadow-sm' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-12574">
            {tab.id === 'client' && <Users className="w-4 h-4 flex-shrink-0" data-id="element-12575" />}
            {tab.id === 'sales' && <ShoppingBag className="w-4 h-4 flex-shrink-0" data-id="element-12576" />}
            {tab.id === 'admin' && <Shield className="w-4 h-4 flex-shrink-0" data-id="element-12577" />}
            {tab.id === 'all' && <MessageSquare className="w-4 h-4 flex-shrink-0" data-id="element-12578" />}
            <span className="hidden sm:inline" data-id="element-12579">{tab.label}</span>
            <span className="sm:hidden" data-id="element-12580">{tab.label}</span>
            {unreadByCategory[tab.id] > 0 && <span className={`min-w-[20px] h-5 flex items-center justify-center text-[11px] font-bold rounded-full px-1.5 ${chatFilter === tab.id ? 'bg-white/25 text-white' : 'bg-rose-500 text-white'}`} data-id="element-12581">
                {unreadByCategory[tab.id]}
              </span>}
          </button>)}
      </div>

      <Card padding="none" className="flex flex-1 overflow-hidden" data-id="element-12582">
        <div className={`
          w-full sm:w-1/3 border-r-0 sm:border-r border-slate-100 flex flex-col bg-slate-50/50
          ${activeChat >= 0 ? 'hidden sm:flex' : 'flex'}
        `} data-id="element-12583">
          <div className="p-3 sm:p-4 border-b border-slate-100" data-id="element-12584">
            <Input placeholder="Поиск диалога..." icon={<Search className="w-4 h-4" data-id="element-12586" />} fullWidth className="mb-0" data-id="element-12585" />
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-12587">
            {filteredChats.length === 0 ? <div className="flex flex-col items-center justify-center py-12 px-4 text-center" data-id="element-12588">
                <MessageSquare className="w-8 h-8 text-slate-300 mb-2" data-id="element-12589" />
                <div className="text-sm text-slate-400" data-id="element-12590">
                  Нет диалогов в этой категории
                </div>
              </div> : filteredChats.map((chat, i) => {
            const originalIndex = chatConversations.indexOf(chat);
            return <div key={originalIndex} onClick={() => setActiveChat(originalIndex)} className={`p-3 sm:p-4 border-b border-slate-100 cursor-pointer hover:bg-slate-100 transition-colors ${originalIndex === activeChat ? 'bg-white border-l-2 border-l-primary' : ''}`} data-id="element-12591">
                    <div className="flex items-start gap-3" data-id="element-12592">
                      {/* Avatar */}
                      <div className="relative flex-shrink-0" data-id="element-12593">
                        {chat.isAdmin ? <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700" data-id="element-12594">
                            <Shield className="w-5 h-5" data-id="element-12595" />
                          </div> : <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold text-white ${chat.category === 'sales' ? 'bg-emerald-500' : ['bg-blue-500', 'bg-amber-500', 'bg-rose-500', 'bg-purple-500', 'bg-cyan-500'][originalIndex % 5]}`} data-id="element-12596">
                            {chat.name.charAt(0)}
                          </div>}
                        {!chat.isAdmin && originalIndex % 3 === 0 && <div className="absolute bottom-0 right-0 w-3 h-3 bg-emerald-500 border-2 border-white rounded-full" data-id="element-12597"></div>}
                      </div>

                      <div className="flex-1 min-w-0" data-id="element-12598">
                        <div className="flex justify-between items-start mb-0.5" data-id="element-12599">
                          <div className="font-bold text-slate-900 text-sm truncate flex items-center gap-1.5" data-id="element-12600">
                            {chat.name}
                            {chat.category === 'sales' && <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-semibold bg-emerald-100 text-emerald-700" data-id="element-12601">
                                Продажа
                              </span>}
                          </div>
                          <div className="text-[10px] text-slate-500 flex-shrink-0 ml-2 mt-0.5" data-id="element-12602">
                            {chat.time}
                          </div>
                        </div>
                        <div className="flex justify-between items-center" data-id="element-12603">
                          <div className="text-xs text-slate-600 truncate pr-2" data-id="element-12604">
                            {chat.msg}
                          </div>
                          {chat.unread > 0 && <Badge variant="pro" className="bg-primary text-white flex-shrink-0 px-1.5 py-0 min-w-[18px] text-center" data-id="element-12605">
                              {chat.unread}
                            </Badge>}
                        </div>
                        {!chat.isAdmin && <div className="text-[10px] text-slate-400 mt-1 truncate" data-id="element-12606">
                            {chat.order}
                          </div>}
                      </div>
                    </div>
                  </div>;
          })}
          </div>
        </div>

        <div className={`
          w-full sm:w-2/3 flex flex-col bg-white
          ${activeChat >= 0 ? 'flex' : 'hidden sm:flex'}
        `} data-id="element-12607">
          {activeChat < 0 ? <div className="flex-1 flex flex-col items-center justify-center text-slate-400" data-id="element-12608">
              <MessageSquare className="w-12 h-12 text-slate-200 mb-3" data-id="element-12609" />
              <div className="text-sm font-medium" data-id="element-12610">Выберите диалог</div>
              <div className="text-xs text-slate-300 mt-1" data-id="element-12611">
                Нажмите на чат слева, чтобы начать
              </div>
            </div> : <>
              {/* Chat Header with Call Buttons */}
              <div className="border-b border-slate-100 bg-white" data-id="element-12612">
                <div className="p-3 sm:p-4 flex justify-between items-center gap-2" data-id="element-12613">
                  <div className="flex items-center gap-3 min-w-0" data-id="element-12614">
                    <button onClick={() => setActiveChat(-1)} className="sm:hidden p-1.5 -ml-1 text-slate-500 hover:text-slate-900" data-id="element-12615">
                      <X className="w-5 h-5" data-id="element-12616" />
                    </button>

                    {/* Header Avatar */}
                    <div className="relative flex-shrink-0 hidden sm:block" data-id="element-12617">
                      {chatConversations[Math.max(0, activeChat)].isAdmin ? <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700" data-id="element-12618">
                          <Shield className="w-5 h-5" data-id="element-12619" />
                        </div> : <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold text-white ${['bg-emerald-500', 'bg-blue-500', 'bg-amber-500', 'bg-rose-500', 'bg-purple-500'][Math.max(0, activeChat) % 5]}`} data-id="element-12620">
                          {chatConversations[Math.max(0, activeChat)].name.charAt(0)}
                        </div>}
                    </div>

                    <div className="flex-1 min-w-0" data-id="element-12621">
                      <div className="font-bold text-slate-900 text-sm flex items-center gap-1.5 truncate" data-id="element-12622">
                        {chatConversations[Math.max(0, activeChat)].name}
                      </div>
                      <div className="text-[11px] flex items-center gap-1 truncate" data-id="element-12623">
                        {chatConversations[Math.max(0, activeChat)].isAdmin ? <span className="text-slate-500" data-id="element-12624">
                            Системные уведомления
                          </span> : <>
                            {Math.max(0, activeChat) % 2 === 0 ? <span className="text-emerald-500 font-medium" data-id="element-12625">
                                Онлайн
                              </span> : <span className="text-slate-400" data-id="element-12626">
                                Был(а) 2ч назад
                              </span>}
                          </>}
                      </div>
                    </div>
                  </div>

                  {/* Call & Video Buttons */}
                  {!chatConversations[Math.max(0, activeChat)].isAdmin && <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-12627">
                      <button onClick={() => {
                  setCallMode('audio');
                  setShowCallModal(true);
                }} className="p-2.5 rounded-xl text-slate-500 hover:text-emerald-600 hover:bg-emerald-50 transition-colors" title="Аудиозвонок" data-id="element-12628">
                        <Phone className="w-5 h-5" data-id="element-12629" />
                      </button>
                      <button onClick={() => {
                  setCallMode('video');
                  setShowCallModal(true);
                }} className="p-2.5 rounded-xl text-slate-500 hover:text-primary hover:bg-indigo-50 transition-colors" title="Видеозвонок" data-id="element-12630">
                        <Video className="w-5 h-5" data-id="element-12631" />
                      </button>
                      <div className="w-px h-6 bg-slate-200 mx-1 hidden sm:block" data-id="element-12632"></div>
                      <button onClick={() => setActiveTab('orders')} className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-medium text-slate-600 hover:bg-slate-50 transition-colors" data-id="element-12633">
                        <Info className="w-3.5 h-3.5" data-id="element-12634" />
                        Детали
                      </button>
                    </div>}
                </div>

                {/* Order Info Bar - pinned below header */}
                {!chatConversations[Math.max(0, activeChat)].isAdmin && <div className="px-3 sm:px-4 pb-3" data-id="element-12635">
                    <div className="flex items-center gap-3 bg-slate-50 rounded-xl px-3 py-2.5 border border-slate-100" data-id="element-12636">
                      <div className="flex items-center gap-2 flex-1 min-w-0" data-id="element-12637">
                        <div className="w-7 h-7 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0" data-id="element-12638">
                          <ShoppingBag className="w-3.5 h-3.5 text-indigo-600" data-id="element-12639" />
                        </div>
                        <div className="min-w-0" data-id="element-12640">
                          <div className="text-xs font-semibold text-slate-800 truncate" data-id="element-12641">
                            {chatConversations[Math.max(0, activeChat)].order}
                          </div>
                          <div className="text-[10px] text-slate-500" data-id="element-12642">
                            {chatConversations[Math.max(0, activeChat)].category === 'sales' ? 'Покупка товара' : chatConversations[Math.max(0, activeChat)].category === 'client' ? 'Консультация • В работе' : 'Системное'}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-12643">
                        {chatConversations[Math.max(0, activeChat)].category === 'client' && <button onClick={() => showToast('Назначить созвон — выберите дату и время')} className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-white border border-slate-200 text-[11px] font-medium text-slate-700 hover:border-indigo-200 hover:text-indigo-700 transition-colors" data-id="element-12644">
                            <Calendar className="w-3 h-3" data-id="element-12645" />
                            <span className="hidden sm:inline" data-id="element-12646">Созвон</span>
                          </button>}
                        <button onClick={() => showToast('Заказ завершён ✓')} className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-emerald-50 border border-emerald-200 text-[11px] font-medium text-emerald-700 hover:bg-emerald-100 transition-colors" data-id="element-12647">
                          <CheckCircle2 className="w-3 h-3" data-id="element-12648" />
                          <span className="hidden sm:inline" data-id="element-12649">Завершить</span>
                        </button>
                      </div>
                    </div>
                  </div>}
              </div>

              <div className="flex-1 p-3 sm:p-4 overflow-y-auto space-y-4 bg-slate-50/30" data-id="element-12650">
                {/* Date Separator */}
                <div className="flex justify-center my-4" data-id="element-12651">
                  <span className="text-[10px] font-medium text-slate-400 bg-slate-100 px-3 py-1 rounded-full" data-id="element-12652">
                    — Сегодня —
                  </span>
                </div>

                {chatConversations[Math.max(0, activeChat)].isAdmin ? <div className="space-y-4" data-id="element-12653">
                    <div className="flex justify-center" data-id="element-12654">
                      <div className="bg-slate-100 rounded-xl px-4 py-3 max-w-[90%] sm:max-w-[85%] text-center" data-id="element-12655">
                        <div className="flex items-center justify-center gap-2 mb-1" data-id="element-12656">
                          <Shield className="w-4 h-4 text-slate-500" data-id="element-12657" />
                          <span className="font-bold text-slate-700 text-sm" data-id="element-12658">
                            Система
                          </span>
                        </div>
                        <p className="text-slate-600 text-sm" data-id="element-12659">
                          Новый заказ #1042 оформлен и ожидает подтверждения.
                        </p>
                        <span className="text-[10px] text-slate-400 mt-2 block" data-id="element-12660">
                          Вчера, 12:00
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-center" data-id="element-12661">
                      <div className="bg-indigo-50 border border-indigo-100 rounded-xl px-4 py-3 max-w-[90%] sm:max-w-[85%] text-center" data-id="element-12662">
                        <div className="flex items-center justify-center gap-2 mb-1" data-id="element-12663">
                          <Shield className="w-4 h-4 text-indigo-500" data-id="element-12664" />
                          <span className="font-bold text-indigo-700 text-sm" data-id="element-12665">
                            Администратор
                          </span>
                        </div>
                        <p className="text-indigo-900 text-sm" data-id="element-12666">
                          Ваш профиль успешно прошёл модерацию. Теперь вы видны
                          в каталоге астрологов.
                        </p>
                        <span className="text-[10px] text-indigo-400 mt-2 block" data-id="element-12667">
                          Сегодня, 10:00
                        </span>
                      </div>
                    </div>
                  </div> : <>
                    <div className="flex justify-start" data-id="element-12668">
                      <div className="bg-slate-100 rounded-2xl rounded-tl-none px-3 sm:px-4 py-2 max-w-[85%] sm:max-w-[80%]" data-id="element-12669">
                        <p className="text-slate-800 text-sm" data-id="element-12670">
                          Здравствуйте! Я оплатила заказ, когда можно ожидать
                          отчёт?
                        </p>
                        <span className="text-[10px] text-slate-400 mt-1 block" data-id="element-12671">
                          14:05
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-end" data-id="element-12672">
                      <div className="bg-primary text-white rounded-2xl rounded-tr-none px-3 sm:px-4 py-2 max-w-[85%] sm:max-w-[80%]" data-id="element-12673">
                        <p className="text-sm" data-id="element-12674">
                          Добрый день,{' '}
                          {chatConversations[Math.max(0, activeChat)].name.split(' ')[0]}
                          ! Отчёт готов, отправляю.
                        </p>
                        <div className="flex items-center justify-end gap-1 mt-1" data-id="element-12675">
                          <span className="text-[10px] text-indigo-200" data-id="element-12676">
                            14:20
                          </span>
                          <CheckCheck className="w-3 h-3 text-indigo-200" data-id="element-12677" />
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-end" data-id="element-12678">
                      <div className="bg-primary text-white rounded-2xl rounded-tr-none px-3 sm:px-4 py-2 max-w-[85%] sm:max-w-[80%] flex items-center gap-3" data-id="element-12679">
                        <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-12680">
                          <FileText className="w-5 h-5 text-white" data-id="element-12681" />
                        </div>
                        <div className="min-w-0 flex-1" data-id="element-12682">
                          <div className="text-sm font-medium truncate" data-id="element-12683">
                            Отчёт_
                            {chatConversations[Math.max(0, activeChat)].name.replace(' ', '_')}
                            .pdf
                          </div>
                          <div className="text-xs text-indigo-200" data-id="element-12684">2.4 MB</div>
                        </div>
                        <div className="flex flex-col items-end justify-between h-full self-end ml-2" data-id="element-12685">
                          <CheckCheck className="w-3 h-3 text-white" data-id="element-12686" />
                          <span className="text-[10px] text-indigo-200 mt-1" data-id="element-12687">
                            14:21
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-start" data-id="element-12688">
                      <div className="bg-slate-100 rounded-2xl rounded-tl-none px-3 sm:px-4 py-2 max-w-[85%] sm:max-w-[80%]" data-id="element-12689">
                        <p className="text-slate-800 text-sm" data-id="element-12690">
                          {chatConversations[Math.max(0, activeChat)].msg}
                        </p>
                        <span className="text-[10px] text-slate-400 mt-1 block" data-id="element-12691">
                          {chatConversations[Math.max(0, activeChat)].time}
                        </span>
                      </div>
                    </div>
                  </>}
              </div>

              {!chatConversations[Math.max(0, activeChat)].isAdmin && <div className="bg-white border-t border-slate-100 flex flex-col" data-id="element-12692">
                  {/* Quick Actions */}
                  <div className="flex gap-2 px-3 sm:px-4 py-2 overflow-x-auto scrollbar-hide border-b border-slate-50 bg-slate-50/50" data-id="element-12693">
                    <button onClick={() => {
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = 'image/*,.pdf,.doc,.docx,.zip';
                input.onchange = e => {
                  const file = (e.target as HTMLInputElement).files?.[0];
                  if (file) {
                    showToast(`Файл "${file.name}" отправлен ✓`);
                  }
                };
                input.click();
              }} className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 rounded-full text-xs font-medium text-slate-600 hover:bg-slate-50 whitespace-nowrap transition-colors" data-id="element-12694">
                      <Paperclip className="w-3.5 h-3.5 text-slate-400" data-id="element-12695" /> Файл
                    </button>
                    <button onClick={() => {
                setCallMode('video');
                setShowCallModal(true);
              }} className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-indigo-200 rounded-full text-xs font-medium text-indigo-600 hover:bg-indigo-50 whitespace-nowrap transition-colors" data-id="element-12696">
                      <Video className="w-3.5 h-3.5 text-indigo-500" data-id="element-12697" />{' '}
                      Видеозвонок
                    </button>
                    <button onClick={() => {
                setCallMode('audio');
                setShowCallModal(true);
              }} className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-emerald-200 rounded-full text-xs font-medium text-emerald-600 hover:bg-emerald-50 whitespace-nowrap transition-colors" data-id="element-12698">
                      <Phone className="w-3.5 h-3.5 text-emerald-500" data-id="element-12699" />{' '}
                      Позвонить
                    </button>
                    <button onClick={() => showToast('Выберите дату и время для созвона')} className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 rounded-full text-xs font-medium text-slate-600 hover:bg-slate-50 whitespace-nowrap transition-colors" data-id="element-12700">
                      <Calendar className="w-3.5 h-3.5 text-slate-400" data-id="element-12701" />{' '}
                      Назначить созвон
                    </button>
                    <button onClick={() => showToast('Заказ завершён ✓')} className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 rounded-full text-xs font-medium text-slate-600 hover:bg-slate-50 whitespace-nowrap transition-colors" data-id="element-12702">
                      <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" data-id="element-12703" />{' '}
                      Завершить заказ
                    </button>
                  </div>

                  {/* Input Area */}
                  <div className="p-3 sm:p-4 flex items-center gap-2" data-id="element-12704">
                    <button onClick={() => showToast('Эмодзи 😊')} className="p-2 text-slate-400 hover:text-primary transition-colors rounded-full hover:bg-slate-50 flex-shrink-0" data-id="element-12705">
                      <Smile className="w-5 h-5" data-id="element-12706" />
                    </button>
                    <input type="text" placeholder="Написать сообщение..." value={chatMessage} onChange={e => setChatMessage(e.target.value)} className="flex-1 min-w-0 rounded-xl border-slate-200 px-3 sm:px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm" onKeyDown={e => {
                if (e.key === 'Enter' && chatMessage.trim()) {
                  showToast('Сообщение отправлено ✓');
                  setChatMessage('');
                }
              }} data-id="element-12707" />
                    <Button variant="primary" icon={<Send className="w-4 h-4" data-id="element-12709" />} className="px-3 flex-shrink-0" disabled={!chatMessage.trim()} onClick={() => {
                if (chatMessage.trim()) {
                  showToast('Сообщение отправлено ✓');
                  setChatMessage('');
                }
              }} data-id="element-12708" />
                  </div>
                </div>}
            </>}
        </div>
      </Card>

      {/* Video Call Modal */}
      <VideoCallModal isOpen={showCallModal} onClose={() => setShowCallModal(false)} mode={callMode} participantName={activeChat >= 0 ? chatConversations[activeChat].name : ''} participantInitials={activeChat >= 0 ? chatConversations[activeChat].name.charAt(0) : ''} onEnd={() => showToast('Звонок завершен')} data-id="element-12710" />
    </div>;
}